module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_Oncologie.a79bcf00.png";